import { configureStore } from "@reduxjs/toolkit";
import wavierReducer from "./features/waiverSlice";
import sliceReducer from "./features/slice";

export const store = configureStore({
  reducer: {
    wavier: wavierReducer,
    slice: sliceReducer,
  },
});
